import axios from "axios";

const addr = "https://staging.vsi.ai";

const reportPrefix = window.location.hostname === "" ? addr : "";
const arbiterPrefix = window.location.hostname === "" ? addr : "";
const autobotPrefix = window.location.hostname === "" ? addr : "";

export const simpleGet = route => axios.get(route);
export const UpdateVirtualHealth = (route, data, user, password) => axios.post(route, data, {
    auth: {
        username: user,
        password: password
    },
    headers: {
        "content-type": "application/json",
        "Accept": "application/json"
        // "X-UserToken": "fcaeaadf478c9210af5b9dbe316d43a430c1849405eeb26a29e31bd74a4854ef1f95e4f5",
        // "X-Transaction-Source": "Interface=Web,Interface-Type=Classic Environment,Interface-Name=Unified Navigation App"
    }
});

export const getReport = (route, config, token) => axios.get(`${reportPrefix}${route}`, {
    ...config,
    headers: {Authorization: `Bearer ${token}`}
});
export const postReport = (route, data, token) => axios.post(`${reportPrefix}${route}`, data, {headers: {Authorization: `Bearer ${token}`}});

export const postUpload = (route, formData, file, token) => axios.post(`${arbiterPrefix}${route}`, formData, {
    headers: {
        "content-type": "multipart/form-data",
        "fileName": file.name,
        Authorization: `Bearer ${token}`
    }
});

export const postBuUpload = (route, formData, config) => axios.post(`${arbiterPrefix}${route}`, formData, config);

export const GetAuth = (route, token) => axios.get(`${arbiterPrefix}${route}`, {headers: {Authorization: `Bearer ${token}`}});
export const PostAuth = (route, data, token) => axios.post(`${arbiterPrefix}${route}`, data, {headers: {Authorization: `Bearer ${token}`}});
export const PutAuth = (route, data, token) => axios.put(`${arbiterPrefix}${route}`, data, {headers: {Authorization: `Bearer ${token}`}});
export const DeleteAuth = (route, token) => axios.delete(`${arbiterPrefix}${route}`, {headers: {Authorization: `Bearer ${token}`}});

export const getAutobot = (route, token) => axios.get(`${autobotPrefix}${route}`, {headers: {Authorization: `Bearer ${token}`}});
export const postAutobot = (route, data, token) => axios.post(`${autobotPrefix}${route}`, data, {headers: {Authorization: `Bearer ${token}`}});
